export default __webpack_public_path__ + "static/media/link-spark.674aacb4.svg";